import type { Crop } from './salesContent';

export const volumes = [
  {
    tag: '01 — Enseñar',
    label: 'Volumen 1',
    title: 'Fundamentos y Método del Instructor',
    headline: 'Aprendé a enseñar, no solamente a explicar.',
    intro: 'Transformá tus conocimientos en una capacitación clara y estructurada.',
    listLabel: 'Incluye:',
    list: [
      'Seguridad de la escena',
      'Bioseguridad',
      'Evaluación inicial',
      'Comunicación efectiva',
      'Didáctica para adultos',
      'Demostración de maniobras',
      'Organización de prácticas',
      'Estaciones de entrenamiento',
      'Corrección de errores',
      'Feedback al alumno',
    ],
    flowLabel: '',
    flow: ['Enseñar', 'Demostrar', 'Practicar', 'Corregir'],
    extra: '',
    crop: { x: 60, y: 180, w: 350, h: 450 } as Crop,
  },
  {
    tag: '02 — Entrenar',
    label: 'Volumen 2',
    title: 'Protocolos, Maniobras y Habilidades Críticas',
    headline: 'Tené organizado qué enseñar frente a las principales emergencias.',
    intro: '',
    listLabel: 'Incluye contenidos sobre:',
    list: [
      'RCP',
      'DEA',
      'Atragantamiento',
      'Hemorragias',
      'Heridas',
      'Quemaduras',
      'Traumatismos',
      'Fracturas',
      'Emergencias médicas',
      'Emergencias pediátricas',
      'Emergencias ambientales',
      'Y más',
    ],
    flowLabel: 'Método central:',
    flow: ['Reconocer', 'Decidir', 'Actuar', 'Pedir ayuda', 'Reevaluar'],
    extra: 'Además: Cómo enseñarlo · Qué errores observar · Cómo practicarlo · Cómo evaluarlo',
    crop: { x: 950, y: 90, w: 345, h: 385 } as Crop,
  },
  {
    tag: '03 — Evaluar',
    label: 'Volumen 3',
    title: 'Entrenamiento, Simulación y Evaluación del Alumno',
    headline: 'Pasá de enseñar una maniobra a comprobar una competencia.',
    intro:
      'Aprendé a organizar prácticas, dirigir simulaciones, observar el desempeño y evaluar si el alumno realmente puede actuar ante una situación.',
    listLabel: 'Incluye:',
    list: [
      'Práctica progresiva',
      'Diseño de simulaciones',
      'Dirección de escenarios',
      'Observación del alumno',
      'Identificación de errores críticos',
      'Feedback',
      'Debriefing',
      'Evaluación práctica',
      'Reentrenamiento',
      'Evaluaciones integradoras',
    ],
    flowLabel: '',
    flow: ['Practicar', 'Simular', 'Observar', 'Evaluar', 'Corregir'],
    extra: '',
    crop: { x: 950, y: 465, w: 360, h: 385 } as Crop,
  },
];